import firebaseApp from './../../utils/firebase/firebase';
import { pointsConfig } from './../../conf/config';

import { BADGE_EARNED } from './../../components/Points/pointsActionTypes';
import { RETRIEVE_ARTICLE_CONTENT_SUCCESS, EMO_REACTION_SUCCESS } from './../../components/Article/articleActionTypes';

const SEND_MESSAGE_SUCCESS = 'SEND_MESSAGE_SUCCESS';
const END_QUIZZ = 'END_QUIZZ';

const updateHistory = (action, entityId, entityValue, points, value) => {
    firebaseApp.database().ref(`users/${ firebaseApp.auth().currentUser.uid }/history`).push({
        action,
        entity:{entityId, entityValue},
        created_at: new Date().getTime(),
        points,
        value
    }).then(()=>{
      const payload = {};
      payload[`/lastUpdate`] = new Date().getTime();
      
      return firebaseApp
        .database()
        .ref(`users/${ firebaseApp.auth().currentUser.uid }` )
        .update(payload)
    }).catch((err)=>{
        console.error('[ACTION LOGGER] updateHistory error : ', err);
    });
}

const updatePoints = ( store, action, points ) => {
    /*let totalPoints = store.getState().points.totalPoints;
    let currentPoints = store.getState().points.currentPoints;*/

    firebaseApp.database().ref(`users/${ firebaseApp.auth().currentUser.uid }/points`).once('value')
        .then((snapshot)=>{

            let totalPoints = (snapshot.val() && snapshot.val().totalPoints) || 0;
            let currentPoints = (snapshot.val() && snapshot.val().currentPoints) || 0;

            if(action==="order")
            {
                currentPoints -= points;
            }
            else if(action==="refund")
            {
                currentPoints += points;
            }
            else{
                currentPoints += points;
                totalPoints += points;
            }

            var updates = {};
            updates[`users/${ firebaseApp.auth().currentUser.uid }/points`] = {
                currentPoints,
                totalPoints
            };

            firebaseApp.database().ref()
                .update(updates);
        })
        .catch((err) => {
            console.error('[ACTION LOGGER] updatePoints error : ', err);
        });
}

const isAlreadyInHistory = (store, action, entity) => {

    let result = false;
    //let history = store.getState().history.history;
    let history;
    return new Promise( resolve => {
        return firebaseApp.database().ref(`users/${ firebaseApp.auth().currentUser.uid }/history`).once('value')
            .then((snapshot)=>{
                history = Object.values(snapshot.val());
                for (var key=0; key<history.length; key++)
                {
                    if(history[key].action === action && history[key].entity.entityId === entity ){
                        result = true;
                    }
                }

                resolve(result);
            })
            .catch((err) => {
                console.error('[ACTION LOGGER] isAlreadyInHistory error : ', err); 
                resolve(result);     
            });

    });
    
}

async function processAction(action, store){
    const {operation=action.payload.action, entityId, entityValue, value, point} = action.payload
    let points = 0;

    let isInHistory = await isAlreadyInHistory(store, operation, entityId)

    if(point === false && !isInHistory && typeof pointsConfig[operation] !== 'undefined')
    {
        points = pointsConfig[operation];
    }
    if(point !== false)
    {
        points = point;
    }

    updateHistory(operation, entityId, entityValue, points, value);

    if (points !== 0)
    {
        updatePoints(store, operation, points);
    }
}


export const dispatchAction = (action, store) => {
    switch(action.type)
    {
        case RETRIEVE_ARTICLE_CONTENT_SUCCESS:
        case EMO_REACTION_SUCCESS:
        case SEND_MESSAGE_SUCCESS:
        case END_QUIZZ:
        case BADGE_EARNED: 
            processAction(action, store);
            break;
        default: 
    }
}


// WEBPACK FOOTER //
// ./src/middleware/ActionLogger/actions.js